import { render } from "./Hatford.vue?vue&type=template&id=16ecfa1f"
import script from "./Hatford.vue?vue&type=script&lang=js"
export * from "./Hatford.vue?vue&type=script&lang=js"

import "./Hatford.vue?vue&type=style&index=0&id=16ecfa1f&lang=css"
script.render = render

export default script